import { SxProps, Theme } from '@mui/system';

const styles = {
  container: {
    backgroundColor: 'secondary.main',
    margin: '16px 24px',
    padding: '24px 32px',
  },
  crumbContainer: {
    mb: '16px',
  },
  title: {
    fontWeight: '600',
    fontSize: 22,
    color: 'common.grey850',
    mb: '16px',
  },
  formContainer: {
    maxWidth: '960px',
  },
  languageTabs: {
    mb: '20px',
    '& .MuiToggleButton-root': {
      minWidth: '120px',
      textTransform: 'none',
    },
  },
  fieldContainer: {
    mb: '16px',
  },
  placeholderContainer: {
    maxWidth: '360px',
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    fontSize: 14,
  },
  imageSectionContainer: {
    minWidth: 600,
  },
  rowLabel: {
    fontSize: 14,
    fontWeight: '500',
    mt: '8px',
    mr: 3,
    flex: 1,
  },
  testEmailContainer: {
    display: 'flex',
  },
  testEmail: {
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    minWidth: 300,
    '& .MuiOutlinedInput-root': {
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0,
    },
  },
  editorContainer: {
    border: '1px solid',
    borderColor: 'grey.300',
    flex: 6,
    borderRadius: '4px',
    overflow: 'hidden',
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    mt: '24px',
  },
  noUnderline: {
    textDecoration: 'none',
    fontSize: 14,
    padding: 0,
  },
  prevLink: {
    color: 'grey.500',
  },
} satisfies Record<string, SxProps<Theme>>;

export default styles;
